<template>
  <div>
    <top-product></top-product>
    <div class="d-flex flex-end">
      <b-button 
          variant="warning"
          class="btn-icon ml-auto mb-2"
          @click="showDetailData=!showDetailData"
        >
        Tüm ürün analizi
        <FeatherIcon icon="ChevronUpIcon" v-if="showDetailData"></FeatherIcon>
        <FeatherIcon icon="ChevronDownIcon" v-else></FeatherIcon>
      </b-button>
    </div>
    <b-card
      no-body
      class="mb-0"
      id="detailDataWrap"
      v-if="showDetailData"
    >
    
    <products></products>

    </b-card>
  </div>
</template>
  
  <script>
  import Products from '../Products.vue'
  import { BRow, BCol, BCard, BCardHeader, BButton, BCardSubTitle, BCardTitle, BTableLite, BTable, BFormCheckbox } from 'bootstrap-vue'
  import vSelect from 'vue-select';
  import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue'
  import TopProduct from './TopProduct.vue';
  
  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BButton,
      BCardHeader,
      BCardSubTitle,
      BCardTitle,
      BTableLite,
      BTable,
      BFormCheckbox,

      Products,
      CampaignLinkBtn,
      TopProduct,
      vSelect
    },
    data() {
      return {  
        detailPopup:false,
        showDetailData:false,
        dataList:[],
        resolvedTableColumns:[
          { key: 'id', label: 'Id'},
          { key: 'image', label: 'Görsel'},
          { key: 'name', label: 'İsim'},
          { key: 'base_price', label: 'Ürün Sabit Fiyatı'},
          { key: 'total_quantity', label: 'Sipariş Adedi'},
          { key: 'orders_total_amount', label: 'Ürün Getirisi'},
          { key: 'show_details', label: 'Siparişler'},
        ]
      }
    },
    watch: {
      showDetailData(newData){
        if(newData==true){
          this.$nextTick(() => {
            const element = document.getElementById('detailDataWrap');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        }
      }
    },
  }
  </script>
  
  <style>
  
  .row-detail-popup{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  </style>